import { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import Logo from './Logo'
import './Header.css'

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [openDropdown, setOpenDropdown] = useState<string | null>(null)
  const navRef = useRef<HTMLElement>(null)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (navRef.current && !navRef.current.contains(event.target as Node)) {
        setOpenDropdown(null)
      }
    }
    if (openDropdown) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [openDropdown])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
    setOpenDropdown(null)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const toggleDropdown = (dropdown: string) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown)
  }

  const productCategories = [
    { name: 'Metal Casework', path: '/products#metal-casework' },
    { name: 'P-lam Casework', path: '/products#p-lam-casework' },
    { name: 'Phenolic Casework', path: '/products#phenolic-casework' },
    { name: 'Countertops', path: '/products#countertops' },
    { name: 'Sinks', path: '/products#sinks' },
    { name: 'Miscellaneous Lab Plumbing Parts', path: '/products#plumbing' },
    { name: 'Specialty Cabinets', path: '/products#specialty-cabinets' },
    { name: 'Fume Hoods', path: '/products#fume-hoods' },
    { name: 'Fume Hood Certification', path: '/fume-hood-certification' },
    { name: 'Safety Equipment', path: '/products#safety-equipment' },
    { name: 'Safety Audit', path: '/products#safety-audit' },
    { name: 'Efficiency Audit', path: '/products#efficiency-audit' },
  ]

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" onClick={closeMenu}>
            <Logo />
          </Link>
          
          <button
            className={`menu-toggle ${isMenuOpen ? 'menu-toggle-open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
          >
            <span className="menu-toggle-line"></span>
            <span className="menu-toggle-line"></span>
            <span className="menu-toggle-line"></span>
          </button>

          <nav ref={navRef} className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <div className="nav-item nav-item-dropdown">
              <button
                className="nav-link nav-link-dropdown"
                onClick={() => toggleDropdown('projects')}
                aria-expanded={openDropdown === 'projects'}
              >
                Completed Projects
                <span className="dropdown-arrow">▼</span>
              </button>
              {(openDropdown === 'projects' || isMenuOpen) && (
                <div className="dropdown-menu">
                  <Link to="/projects" className="dropdown-link" onClick={closeMenu}>
                    View All Projects
                  </Link>
                  <Link to="/projects#gallery" className="dropdown-link" onClick={closeMenu}>
                    Project Gallery
                  </Link>
                  <Link to="/projects#testimonials" className="dropdown-link" onClick={closeMenu}>
                    Project Testimonials
                  </Link>
                </div>
              )}
            </div>

            <div className="nav-item nav-item-dropdown">
              <button
                className="nav-link nav-link-dropdown"
                onClick={() => toggleDropdown('products')}
                aria-expanded={openDropdown === 'products'}
              >
                Available Products
                <span className="dropdown-arrow">▼</span>
              </button>
              {(openDropdown === 'products' || isMenuOpen) && (
                <div className="dropdown-menu dropdown-menu-wide">
                  {productCategories.map((category) => (
                    <Link
                      key={category.path}
                      to={category.path}
                      className="dropdown-link"
                      onClick={closeMenu}
                    >
                      {category.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link to="/testimonials" className="nav-link" onClick={closeMenu}>
              Testimonials
            </Link>
            <Link to="/about" className="nav-link" onClick={closeMenu}>
              About Us
            </Link>
            <Link to="/contact" className="nav-link nav-link-cta" onClick={closeMenu}>
              Contact Us
            </Link>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
